/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import classes from './index.module.css';

export default function Buttons({
  backUrl, nextUrl, isDisabled, backText = '← Back', nextText = 'Continue →',
  loading, onSubmit,
}) {
  return (
    <>
      <Link to={backUrl}>
        <Button className={classes.back_button}>{backText}</Button>
      </Link>
      <Link to={isDisabled ? '' : nextUrl}>
        <Button
          type="primary"
          disabled={isDisabled}
          className={classes.next_button}
          onClick={onSubmit}
          loading={loading}
          htmlType="submit"
        >
          {nextText}
        </Button>
      </Link>
    </>
  );
}
